
import { Course } from "@/types/course";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";

interface CourseGridProps {
  courses: Course[];
  username: string;
  creatorName: string | null;
}

export const CourseGrid = ({ courses, username, creatorName }: CourseGridProps) => {
  if (courses.length === 0) {
    return (
      <div className="text-center py-12 bg-muted/20 rounded-lg">
        <p className="text-muted-foreground">No courses available yet.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {courses.map((course) => (
        <Link 
          key={course.id} 
          to={`/${username}/${course.slug}`}
          className="block"
        >
          <Card className="h-full overflow-hidden hover:shadow-md transition-shadow">
            <div 
              className="aspect-video w-full bg-muted bg-cover bg-center" 
              style={{ backgroundImage: course.thumbnail_url ? `url(${course.thumbnail_url})` : undefined }}
            ></div>
            <CardContent className="p-4">
              <h3 className="font-semibold text-lg mb-1 line-clamp-1">{course.title}</h3>
              <p className="text-muted-foreground text-sm line-clamp-2">{course.description}</p>
              {course.price !== null && course.price > 0 ? (
                <div className="mt-2">
                  <span className="inline-block px-2 py-1 bg-primary/10 text-primary rounded text-sm font-medium">
                    ${course.price}
                  </span>
                </div>
              ) : (
                <div className="mt-2">
                  <span className="inline-block px-2 py-1 bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 rounded text-sm font-medium">
                    Free
                  </span>
                </div>
              )}
            </CardContent>
          </Card>
        </Link>
      ))}
    </div>
  );
};
